module.exports = __webpack_public_path__ + "img/dawn-dusk-hd-wallpaper-36717.059715b3.jpg";